import React, {Component} from "react";
import {Chat, ChannelList, ChannelListMessenger, withChatContext} from "stream-chat-react";
import Users from "./Users";
import CustomChannelPreview from "./CustomChannelPreview";
import SupportChannelPreview from "./SupportChannelPreview";
import ConversationBox from "./ConversationBox";

import "stream-chat-react/dist/css/index.css";
import styles from '../styles/general.module.scss';

import {allHelpRoles, helpRoles, qaRoles} from "../local_roles";


const CustomEmptyStateIndicator = () => {
    return (
        <div className={styles.noChannels}>No active conversations</div>
    )
};

const CustomLoadingIndicator = () => {
    return (
        <div />
    )
};


class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            qaChannel: null,
            helpChannel: null
        };
    }


    async componentDidMount() {
        const {chatClient, user, showHelp, showQA, childRef} = this.props;
        const isHelpUser = helpRoles.includes(user.local_role);
        const isQaUser = qaRoles.includes(user.local_role);
        const isSupportUser = isQaUser || isHelpUser;

        childRef(this);

        if (isSupportUser) {
            // hide empty channels, they will show up if new message comes in
            /*const allChannels = await chatClient.queryChannels({type: 'messaging'}, {}, {limit: 30});
            allChannels.forEach((ch) => {
                if (ch.state.messages.length === 0) {
                    console.log(ch);
                    // hide empty channels !
                }
            })*/

        } else {
            // create QA channel between this user and qa users
            if (showQA) {
                const qaChannel = await this.createSupportChannel('qa');
                this.setState({qaChannel});
            }
            // create Help channel between this user and help user
            if (showHelp) {
                const helpChannel = await this.createSupportChannel('help');
                this.setState({helpChannel});
            }
        }

        this.setState({loaded: true});
    }

    componentWillUnmount() {
        const { childRef } = this.props;
        childRef(undefined);
    }

    createSupportChannel = async (type) => {
        const {chatClient, user} = this.props;
        const roles = type === 'qa' ? qaRoles : helpRoles;

        const supportUsers = await chatClient.queryUsers(
            { local_role: {$in : roles} },
        );

        if (supportUsers.users.length > 0) {
            const channelUsers = supportUsers.users.map(u => u.id);
            channelUsers.push(user.id);

            const channel = chatClient.channel("messaging", `${user.id}-${type}`, {
                name: `${user.id}-${type}`,
                members: channelUsers,
                supporttype: type
            });

            const response = await channel.create();
            const membersInChannel = response.members.map(m => m.user.id);

            const membersToRemove = response.members
                .filter(m => !roles.includes(m.user.local_role) && m.role !== 'owner')
                .map(u => u.user.id);

            if (membersToRemove.length > 0) {
                await channel.removeMembers(membersToRemove);
            }

            if (channelUsers.some(mid => !membersInChannel.includes(mid))) {
                await channel.addMembers(channelUsers);
            }

            await channel.watch();
            await channel.show();

            return channel;
        }

        return null;
    };

    getUserChannels = () => {
        const {user, hideUsers} = this.props;
        const isSupportUser = allHelpRoles.includes(user.local_role);

        if (isSupportUser) {
            return (
                <ChannelList
                    key={`channel-list-attendees`}
                    filters={{type: 'messaging', members: {$in: [user.id]}}}
                    sort={{has_unread: -1}}
                    List={ChannelListMessenger}
                    Preview={CustomChannelPreview}
                    EmptyStateIndicator={CustomEmptyStateIndicator}
                    LoadingIndicator={CustomLoadingIndicator}
                    setActiveChannelOnMount={false}
                    me={user}
                />
            );
        } else if (!hideUsers) {
            return (
                <ChannelList
                    key={`channel-list-users`}
                    filters={{
                        type: 'messaging',
                        members: {$in: [user.id]},
                        id: {$nin: [`${user.id}-help`, `${user.id}-qa`]}
                    }}
                    sort={{last_message_at: -1}}
                    List={ChannelListMessenger}
                    Preview={CustomChannelPreview}
                    EmptyStateIndicator={CustomEmptyStateIndicator}
                    LoadingIndicator={CustomLoadingIndicator}
                    setActiveChannelOnMount={false}
                    me={user}
                />
            );
        }

        return null;
    };

    getQAChannel = () => {
        const {user, showQA} = this.props;
        const {qaChannel} = this.state;
        const isSupportUser = allHelpRoles.includes(user.local_role);

        if (!showQA || isSupportUser || !qaChannel) return null;

        return (
            <SupportChannelPreview channel={qaChannel} key="channel-list-qa" />
        );
    };

    getHelpChannel = () => {
        const {user, showHelp} = this.props;
        const {helpChannel} = this.state;
        const isSupportUser = allHelpRoles.includes(user.local_role);

        if (!showHelp || isSupportUser || !helpChannel) return null;

        return (
            <SupportChannelPreview channel={helpChannel} key="channel-list-help" />
        );
    };

    startOneToOneChat = (partnerId) => {
        this.usersRef && this.usersRef.startOneToOneChat(partnerId)
    }

    render () {
        const {chatClient, user, openDir, hideUsers, pullUsers} = this.props;
        const {loaded} = this.state;

        return (
            <Chat client={chatClient} theme={"messaging light"} initialNavOpen={false}>
                {loaded &&
                    <div className="list-group">
                        {this.getQAChannel()}
                        {this.getHelpChannel()}
                        {this.getUserChannels()}
                        {!hideUsers && <hr/>}
                    </div>
                }
                {!hideUsers && <Users user={user} pullUsers={pullUsers} childRef={ref => (this.usersRef = ref)} />}
                <ConversationBox chatClient={chatClient} user={user} openDir={openDir} />
            </Chat>
        );
    }
};

export default withChatContext(App);

